import MicroModal from 'micromodal';  // es6 module

export class MicroModalClass {
  constructor() {
    this.init();
  }

  init = () => {
    MicroModal.init({
      //onShow: modal => console.info(`${modal.id} is shown`),
      //onClose: modal => console.info(`${modal.id} is hidden`),
      disableScroll: true,
      disableFocus: false,
      awaitCloseAnimation: false,
      debugMode: false,
      onShow: modal => {
        if(modal.id === 'appointmentModal'){
          let contactPopup = document.getElementById('contactPopup');
          contactPopup.classList.remove('active')
        }
      }
    });
  }

  showModal(id){
    MicroModal.show(id);
  }
  closeModal(id){
    MicroModal.close(id);
  }
}
